import React, { Component } from "react";
import { connect } from "react-redux";

//IMPORT COMPONENT
import Menu         from "../Components/component_Menu";
import Loader       from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
import BuyVersion   from "../Components/component_BuyVersion";
import SGButtonsBar from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import {List, ListItem }                     from "material-ui/List"
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";

import IconPdf       from "material-ui/svg-icons/image/picture-as-pdf";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
import IconWord      from "material-ui/svg-icons/av/library-books"
import IconAdd       from "material-ui/svg-icons/content/add";
import IconExcel     from "material-ui/svg-icons/av/library-add";
import IconDownload  from "material-ui/svg-icons/file/cloud-download";

import "../CSS/icon-font/icon-file-type/css/style.css"; // Importo il font per le icone dei tipi di file

import { getCampiPersonalizzatiList } from "../Actions/Action_ServiceRequest_Campi";
import { getExportDownload, getFileTypeToDownload, dialogDownload_Close, getListaPesate, dialogDetails_Close, getDettaglioPesata, orderListaPesate, getFiltriPesate, setInternalFilter, setFiltriPesate, removeFilter, getLogicalOperator , addFilter, dialogFiltri_Close, dialogFiltri_Open }   from "../Actions/Action_ServiceRequest_Pesate";
import { getUserInfo }                        from "../Actions/Action_Authentication";
import { getListaAziendeTupla }               from "../Actions/Action_ServiceRequest_Azienda";
import { getListaImpiantiTupla }              from "../Actions/Action_ServiceRequest_Impianti";
import Chip from 'material-ui/Chip';

import Moment from "react-moment";
import momentformat from 'moment';

//UTILS
import { checkFloatInput } from "../Utils/Check_Value";
import * as ROLES  from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
import { checkNull, checkUserLanguage } from "../Utils/Check_Value";
import { LABEL_Required, LABEL_NoResult, LABEL_Close, LABEL_Cancel, LABEL_True, LABEL_False, LABEL_Save, LABEL_Yes, LABEL_No, LABEL_Deleted,LABEL_OrderBy,LABEL_CreatedBy, LABEL_Number, 
         LABEL_FileName, LABEL_InvalidValue, LABEL_Filter_Apply, LABEL_Filter_RemoveFilters, LABEL_Filter_Either, LABEL_Filter_OnlyDeleted, LABEL_Filter_OnlyActive, LABEL_FilterSet,
         LABEL_Weigh, LABEL_DateStart, LABEL_DateEnd, LABEL_MinimumWeight, LABEL_MaximumWeight, LABEL_FirstWeight, LABEL_SecondWeight, LABEL_FirstWeightDate, 
         LABEL_Choose_FileType, LABEL_SecondWeightDate, LABEL_FirstMPP, LABEL_ExportWeighings, LABEL_Download, LABEL_SecondMPP, LABEL_Enter_Description, LABEL_Net, LABEL_Enter_MinimumWeight, LABEL_Enter_MaximumWeight, 
         LABEL_DIALOG_Weigh_Details, LABEL_PAGE_Weigh, LABEL_User, LABEL_FirstWeighting, LABEL_Company, LABEL_Plant, LABEL_Libra, LABEL_SecondWeighting, LABEL_PAGE_CustomFields, LABEL_Enter_Value, LABEL_LogicalOperator, LABEL_Field, LABEL_Filters, LABEL_Choose_Holding, LABEL_Choose_Company, LABEL_Choose_Plant } from "../Utils/Strings/Labels";
import { URL_REPORT } from "../Utils/Strings/URL";                          


const USERINFO      = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null : USERINFO.Holding ? USERINFO.Holding.ID : null;
const USERIDAZIENDA = USERINFO == null ? null : USERINFO.Azienda == null ? null : USERINFO.Azienda.ID;
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const USERLANGUAGE  = checkUserLanguage(USERINFO);

const reportPDF = 5;
const reportDOC = 3;
const reportEXC = 8;

const styles = {
  propContainer: {
    width: 200,
    overflow: "hidden",
    margin: "20px auto 0"
  },
  propToggleHeader: {
    margin: "20px auto 10px"
  },
  filterDialog : {
    width : '100%',
    maxWidth : 'none'
  }
};

class Pesate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //Table
      fixedHeader: true,
      fixedFooter: true,
      stripedRows: false,
      showRowHover: true,
      selectable: true,
      multiSelectable: false,
      enableSelectAll: true,
      deselectOnClickaway: false,
      showCheckboxes: false,
      height: '700px',
      selectedList : [],
      //Dialog
      filterDialogOpen : false,
      ShowDetailsDialogOpen: false,
      //Ordinamento
      ordinaPer : null,
      //Filter
      filter: {
        Cancellata     : null,
        IDAziendaUno   : USERIDAZIENDA || 0,     
	      IDAziendaDue   : USERIDAZIENDA || 0,
	      IDImpiantoUno  : null,
	      IDImpiantoDue  : null,
	      IDBilanciaUno  : null,
	      IDBilanciaDue  : null,
	      dataInizioUno  : null,
	      dataFineUno    : null,
	      dataInizioDue  : null,
	      dataFineDue    : null,
	      primoPesoMin   : null,
	      primoPesoMax   : null,
	      secondoPesoMin : null,
        secondoPesoMax : null,
        IDHolding      : USERIDHOLDING,
      },
      filterModalError : {
        msgErrorPrimoPesoMin   : "",
        msgErrorPrimoPesoMax   : "",
        msgErrorSecondoPesoMin : "",
        msgErrorSecondoPesoMax : "" 
      },
      selezioneManuale : true,
      customFilter : {

      },
      downloadDialog : {
        fileTypeSelected : null,
        fileName : null
      }
    }
    
    console.log(CANUSEPAGE)
    if (CANUSEPAGE) this.props.dispatch(getFiltriPesate());
  }

  
  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => {
    var r = row[0];
    var elem = this.props.pesateList[r];
    if(!checkNull(elem))
      this.props.dispatch(getDettaglioPesata(elem.IDMaster));
    this.setState({ selectedList : row });
  }

  handleFilerDialogOpen  = () => this.setState({filterDialogOpen : true});

   //Funzione per l'ok dei filtri
   handleFilerDialogClose = () =>{
     this.props.dispatch(getListaPesate(this.state.filter));
     this.setState({filterDialogOpen : false});
   }

  handleShowDetailsClose = () => this.setState({ShowDetailsDialogOpen : false})

  handleOrderChange = (event, index, value) => (this.state.ordinaPer = value) &&  this.props.dispatch(orderListaPesate(this.props.pesateList, value))

  handleChangeMinDateUno = (event, date) => {
    var filter = this.state.filter;
    filter.DataInizioUno = momentformat(date).format("YYYY-MM-DD");
    this.setState({ minDateUno : date, filter : filter })
    this.props.dispatch(getListaPesate(filter));
  }

  handleChangeMaxDateUno = (event, date) => {
    var filter = this.state.filter;
    filter.DataFineUno = momentformat(date).format("YYYY-MM-DD");
    this.setState({ maxDateUno: date, filter: filter });
    this.props.dispatch(getListaPesate(filter));
  }

  handleChangeMinDateDue = (event, date) => {
    var filter = this.state.filter;
    filter.DataInizioDue = momentformat(date).format("YYYY-MM-DD");
    this.setState({ minDateDue : date, filter : filter })
    this.props.dispatch(getListaPesate(filter));
  }

  handleChangeMaxDateDue = (event, date) => {
    var filter = this.state.filter;
    filter.DataFineDue = momentformat(date).format("YYYY-MM-DD");
    this.setState({ maxDateDue: date, filter: filter });
    this.props.dispatch(getListaPesate(filter));
  }

  //Funzione per l'evento nel toggle per visualizzare le pesate cancellate
  handleShowDeleted = (event, toggle) => {
    var filter = this.state.filter;
    filter.Cancellata = toggle;
    this.setState({filter: filter});
    this.props.dispatch(getListaPesate(this.state.filter));
  }

  handleDeleteFilter = () => {
    var f = this.state.filter;
    f.SecondoPesoMax = f.SecondoPesoMin = f.PrimoPesoMax = f.PrimoPesoMin = f.Cancellata = f.DataInizioUno = f.DataInizioDue = f.DataFineUno = f.DataFineDue = null;
    this.setState({filter : f, maxDateDue:null, minDateDue:null, maxDateUno:null, minDateUno:null});
    this.forceUpdate();
  }

  componentDidMount = () => {
    if(!CANUSEPAGE) return;
    this.props.dispatch(getUserInfo());
    this.props.dispatch(getListaPesate(this.state.filter));
    if(this.state.filter.IDHolding != null )
      this.props.dispatch(getListaAziendeTupla(this.state.filter.IDHolding))
    
  }

  componentWillMount = () => {
    if(!CANUSEPAGE) return;
      this.props.dispatch(getCampiPersonalizzatiList({ IDHolding: this.state.filter.IDHolding, IDTabella: 0}));
      this.props.dispatch(getLogicalOperator());
  }

  componentWillReceiveProps(newProps){
    if(!CANUSEPAGE) return;
    if(newProps.aziendeList.length === 1){
      var filter = this.state.filter;
      var SelezioneManuale = this.state.selezioneManuale;
      filter.IDAziendaUno  = newProps.aziendeList[0].ID;
      filter.IDAziendaDue  = newProps.aziendeList[0].ID;
      filter.IDAzienda     = newProps.aziendeList[0].ID;
      if(SelezioneManuale){
        SelezioneManuale = false;
        //this.handleChangeImpianto(null, null, null);
        this._setFiltroX("IDAzienda", newProps.aziendeList[0].ID, false, true);
        this.props.dispatch(getListaImpiantiTupla(filter.IDHolding, newProps.aziendeList[0].ID))
        setTimeout(() => this.setState({filter:filter, selezioneManuale: SelezioneManuale}), 100);
      }
      this.setState({filter:filter, selezioneManuale: SelezioneManuale});
    }
  }

  _setFiltroX(campoTabella, value, delAzienda, delImpianto){
    console.log("delete Azienda", delAzienda)
    console.log("delete Impanto", delImpianto)

    var filtri = [];
    //controllo se non esiste il valore IDAzienda e lo aggiungo altrimenti lo modifico
    var toAdd = true;
    this.props.listaFiltri.forEach( f => {
        if(delAzienda && f.CampoTabella === "IDAzienda") return;
        if(delImpianto && f.CampoTabella === "IDImpianto") return;
        if(f.CampoTabella === campoTabella /*&& value !== null*/) {
          f.Filtro = value; toAdd = false; 
          console.log("f.CampoTabella ", f.CampoTabella)
          console.log("campoTabella ", campoTabella)
          console.log("valore ", value)
        }
        filtri.push(f) 
    } )
    if(toAdd) filtri.push({CampoTabella: campoTabella, Filtro: value+"", Operatore : this.props.logicalOperators[0]});
    this.props.dispatch(setFiltriPesate(filtri));
    this.props.dispatch(addFilter({CampoTabella: campoTabella, Filtro: value+"", Operatore : this.props.logicalOperators[0]}));
    this.props.dispatch(setInternalFilter(filtri));
  }

  handleChangeImpianto = (event, index, value) => {
    var selectedImpianto = this.state.filter;
    selectedImpianto.IDImpiantoUno = value;
    selectedImpianto.IDImpiantoDue = value;
    this.setState({ filter: selectedImpianto });
    this._setFiltroX("IDImpianto", value, false, false);
  };

  handleChangeAzienda = (event, index, value) => {
    var selectedAzienda = this.state.filter;
    selectedAzienda.IDAzienda    = value;
    selectedAzienda.IDAziendaUno = value;
    selectedAzienda.IDAziendaDue = value;
    selectedAzienda.IDImpiantoUno = null;
    selectedAzienda.IDImpiantoDue = null;
    this.setState({ filter: selectedAzienda });
    this.props.dispatch(getListaImpiantiTupla( selectedAzienda.IDHolding, selectedAzienda.IDAzienda));
    this._setFiltroX("IDAzienda", value, false, true);
  };

  handleChangeHolding = (event, index, value) => {
    var selectedHolding = this.state.filter;
    selectedHolding.IDAziendaUno  = null;
    selectedHolding.IDAziendaDue  = null;
    selectedHolding.IDImpiantoUno = null;
    selectedHolding.IDImpiantoDue = null;
    selectedHolding.IDHolding     = value;
    this.setState({ filter: selectedHolding });
    this._setFiltroX("IDAzienda", value, true, true);
    this._setFiltroX("IDHolding", value);
  };

  //Funzione per il controllo dei valori inseriti come float nel modal dei filtri
  handleOnChangeMinMax(value, position){
    var filter           = this.state.filter;
    var filterModalError = this.state.filterModalError;

    if(value == ""){
      filter[position] = null;
      this.setState({filter : filter});
      return;
    }
    //Controllo il nuovo valore
    value = value.replace(",", ".");
    if( checkFloatInput(value) ){
      filterModalError["msgError"+position] = "";
      filter[position] = parseFloat(value);
    }else{
      filterModalError["msgError"+position] = LABEL_InvalidValue[USERLANGUAGE];
      filter[position] = value;
    }
    this.setState({ filterModalError : filterModalError, filter : filter });
  };

  //generate report 
  generateReport = filetype =>{
    console.log(this.state.filter);

    var form = document.createElement("form");
    form.setAttribute("method", "get");
    form.setAttribute("action", URL_REPORT + "?IDAziendaUno=" + this.state.filter.IDAzienda + "&FileType=" + filetype);

    form.setAttribute("target", "view");

    var hiddenField = document.createElement("input"); 
      hiddenField.setAttribute("name", "FileType");
      hiddenField.setAttribute("value", filetype);
    form.appendChild(hiddenField);
    hiddenField = document.createElement("input"); 
      hiddenField.setAttribute("name", "IDAziendaUno");
      hiddenField.setAttribute("value", this.state.filter.IDAzienda);
    form.appendChild(hiddenField);
    document.body.appendChild(form);

    window.open('', "view");

    form.submit();
  }

  customFilterChange = (position, value) => {
    var customFilter = this.state.customFilter;
    customFilter[position] = value;
    if(position === "CampoPersonalizzato") {
      customFilter["Operatore"] = null;
      customFilter["Filtro"] = (customFilter[position].TipoCampo && customFilter[position].TipoCampo.ID) === 3 ? false : null;
    }
    this.setState({ customFilter: customFilter });
  };

  _extractFilter = (position, value) => {
    for(var i=0, e; e = this.props.listaFiltri[i]; i++){
      if(e[position] === value) return e;
    }
    return {};
  }

  addCustomFilterInList = () => {
    var customFilter = this.state.customFilter;
     var flag = true;

     if( checkNull(customFilter.Operatore) ){
        customFilter.OperatoreError = LABEL_Required[USERLANGUAGE];
        flag=false;
     }else customFilter.OperatoreError = null;

     if( checkNull(customFilter.CampoPersonalizzato) ){
        customFilter.CampoPersonalizzatoError = LABEL_Required[USERLANGUAGE];
        flag=false;
     }else customFilter.CampoPersonalizzatoError = null;

     if( checkNull(customFilter.Filtro) ){
        customFilter.FiltroError = LABEL_Required[USERLANGUAGE];
        flag=false;
     }else customFilter.FiltroError = null;

     if(flag){
        this.props.dispatch(addFilter(customFilter));
        //setTimeout(() => this.forceUpdate(), 150);
        customFilter={};
     }
     this.setState({ customFilter: customFilter });
  }

  handleRequestDeleteFilter = (index) => {
    var filtri = this.props.listaFiltri.filter( ( item, i ) => i !== index );
    this.props.dispatch(setFiltriPesate(filtri));
    this.props.dispatch(setInternalFilter(filtri));
  }

  handleChangeFileType = (event, index, value) => {
    var downloadDialog = this.state.downloadDialog;
    downloadDialog.fileTypeSelected = value;
    this.setState({ downloadDialog: downloadDialog });
  };

  downloadDialogChange(position, value){
    var downloadDialog = this.state.downloadDialog;
    downloadDialog[position] = value;
    if(checkNull(value))
      downloadDialog[position+"Error"] = LABEL_Required[USERLANGUAGE];
    this.setState({ downloadDialog: downloadDialog });
  }

  downloadDialog_Download = () => {
    var flag = true;
    var downloadDialog = this.state.downloadDialog;
    
    if(checkNull(downloadDialog.FileName)){
      downloadDialog.FileNameError = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else downloadDialog.FileNameError = null;

    if(checkNull(downloadDialog.fileTypeSelected)){
      downloadDialog.fileTypeSelectedError = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else downloadDialog.fileTypeSelectedError = null;
    
    if(flag){
      //this.props.dispatch(getExportDownload(downloadDialog));
      var form = document.createElement("form");
      form.setAttribute("method", "GET");
      form.setAttribute("action", URL_REPORT);

      form.setAttribute("target", "view");

      var hiddenField = document.createElement("input"); 
        hiddenField.setAttribute("name", "MediaTypeHeaderValue");
        hiddenField.setAttribute("value", downloadDialog.fileTypeSelected.MediaTypeHeaderValue);
      form.appendChild(hiddenField);
      hiddenField = document.createElement("input"); 
        hiddenField.setAttribute("name", "FileName");
        hiddenField.setAttribute("value", downloadDialog.FileName);
      form.appendChild(hiddenField);
      hiddenField = document.createElement("input"); 
        hiddenField.setAttribute("name", "ExportFormatType");
        hiddenField.setAttribute("value", downloadDialog.fileTypeSelected.ExportFormatType);
      form.appendChild(hiddenField);
      hiddenField = document.createElement("input"); 
        hiddenField.setAttribute("name", "FileExtension");
        hiddenField.setAttribute("value", downloadDialog.fileTypeSelected.FileExtension);
      form.appendChild(hiddenField);
      hiddenField = document.createElement("input"); 
        hiddenField.setAttribute("name", "IDUser");
        hiddenField.setAttribute("value", USERINFO.IDUser);
      form.appendChild(hiddenField);
      document.body.appendChild(form);

      window.open('', "view");

      form.submit();
    }
    this.setState({downloadDialog:downloadDialog})
  }

  render() {
    const filterDialogActions = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={() => this.props.dispatch(dialogFiltri_Close())}/>,
      <RaisedButton
        label={LABEL_Filter_Apply[USERLANGUAGE]}
        primary={true}
        onClick={()=> this.props.dispatch(setFiltriPesate(this.props.listaFiltri))}
      />
    ];

    const showDetailsActions = [
      <RaisedButton
        label={LABEL_Close[USERLANGUAGE]}
        primary={true}
        onClick={() => this.props.dispatch(dialogDetails_Close())}
      />,
    ];

    const showDownloadActions = [
      <RaisedButton
        label={LABEL_Close[USERLANGUAGE]}
        primary={false}
        onClick={() => this.props.dispatch(dialogDownload_Close())}
      />,
      <RaisedButton
        label={LABEL_Download[USERLANGUAGE]}
        primary={true}
        onClick={() => this.downloadDialog_Download()}
      />,
    ];

    const btnBarList = [
      {
        icon    : <IconRefresh />,
        onClick : () => (CANUSEPAGE) && this.props.dispatch(getListaPesate(this.state.filter)),
        tooltip : "Refresh"
      },
      {
        icon    : <IconDownload/>,
        onClick : () => (CANUSEPAGE) && this.props.dispatch(getFileTypeToDownload()),
        tooltip : "Download"
      },
    ];

    return (
      <div>
        <Menu
          pageName={LABEL_PAGE_Weigh[USERLANGUAGE]}
          rightNavButtonIcon={!CANUSEPAGE ? null : <IconFilter/>}
          rightNavButtonFunction={() => this.props.dispatch(dialogFiltri_Open())}
          Language={USERLANGUAGE}/>
          <Loader isFetching={this.props.isFetching}/>
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
          <ErrorMessage message={this.props.errorMessage} />
          <GoToLogin isAuthenticated = {this.props.isAuthenticated} delay={500}/>
          <div className="my-body">
          {/*TASTI*/}
          <div>
            {
            <Grid>
                <Row>
                  { USERIDHOLDING == null &&
                    <Col sm12={6} lg12={3} xl12={3}>
                      <SelectField
                          floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                          value={this.state.filter.IDHolding}
                          onChange={this.handleChangeHolding}>
                            {  this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  ) }
                      </SelectField>
                    </Col>
                  }
                  { this.state.filter.IDHolding != null && ( USERINFO.Role.ID === ROLES.ADMINISTRATOR_IS_ID || USERINFO.Role.ID === ROLES.ADMINISTRATOR_HOLDING_ID ) &&
                    <Col sm12={6} lg12={3} xl12={3}>
                      <SelectField
                          floatingLabelText={LABEL_Choose_Company[USERLANGUAGE]}
                          value={~~this._extractFilter("CampoTabella", "IDAzienda").Filtro || this.state.filter.IDAzienda}
                          onChange={this.handleChangeAzienda}
                          disabled={this.props.aziendeList.length == 1}>
                          <MenuItem key={null} value={null} primaryText={""}/>
                            {  this.props.aziendeList && this.props.aziendeList.map( azienda => <MenuItem key={azienda.ID} value={azienda.ID} primaryText={azienda.Nome}/>  ) }
                      </SelectField>
                    </Col>
                  }
                  { this.state.filter.IDAzienda != null &&
                    <Col sm12={6} lg12={3} xl12={3}>
                      <SelectField
                          floatingLabelText={LABEL_Choose_Plant[USERLANGUAGE]}
                          value={this.state.filter.IDImpiantoUno}
                          onChange={this.handleChangeImpianto}>
                          <MenuItem key={null} value={null} primaryText={""}/>
                            {  this.props.impiantiList && this.props.impiantiList.map( impianto => <MenuItem key={impianto.ID} value={impianto.ID} primaryText={impianto.Nome}/>  ) }
                      </SelectField>
                    </Col>
                  }
                  <Col sm12={6} lg12={3} xl12={3}>
                    <SelectField
                      style={{float: "right"}}
                      floatingLabelText={LABEL_OrderBy[USERLANGUAGE]}
                      value={this.state.ordinaPer}
                      onChange={this.handleOrderChange}
                    >
                      <MenuItem value = {"PrimaPesata.Peso"}          primaryText = {LABEL_FirstWeight[USERLANGUAGE]}      rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"PrimaPesata.PesoDESC"}      primaryText = {LABEL_FirstWeight[USERLANGUAGE]}      rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"SecondaPesata.Peso"}        primaryText = {LABEL_SecondWeight[USERLANGUAGE]}     rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"SecondaPesata.PesoDESC"}    primaryText = {LABEL_SecondWeight[USERLANGUAGE]}     rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"PrimaPesata.DataOra"}       primaryText = {LABEL_FirstWeightDate[USERLANGUAGE]}  rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"PrimaPesata.DataOraDESC"}   primaryText = {LABEL_FirstWeightDate[USERLANGUAGE]}  rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"SecondaPesata.DataOra"}     primaryText = {LABEL_SecondWeightDate[USERLANGUAGE]} rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"SecondaPesata.DataOraDESC"} primaryText = {LABEL_SecondWeightDate[USERLANGUAGE]} rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"PrimaPesata.Mpp"}           primaryText = {LABEL_FirstMPP[USERLANGUAGE]}         rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"PrimaPesata.MppDESC"}       primaryText = {LABEL_FirstMPP[USERLANGUAGE]}         rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"SecondaPesata.Mpp"}         primaryText = {LABEL_SecondMPP[USERLANGUAGE]}        rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"SecondaPesata.MppDESC"}     primaryText = {LABEL_SecondMPP[USERLANGUAGE]}        rightIcon = { <IconArrowDown  /> } />
                      <MenuItem value = {"Cancellata"}                primaryText = {LABEL_Deleted[USERLANGUAGE]}          rightIcon = { <IconArrowUp    /> } />
                      <MenuItem value = {"CancellataDESC"}            primaryText = {LABEL_Deleted[USERLANGUAGE]}          rightIcon = { <IconArrowDown  /> } />
                    </SelectField>
                  </Col>
                </Row>
              </Grid>
          }
            <Grid>
              {/*<Row>
                <Col sm12={11}><center><RaisedButton className="button-table" icon={<IconFilter/>} onClick={() => this.props.dispatch(dialogFiltri_Open())} buttonStyle={STYLES.sg_Button} /></center></Col>
              </Row>*/}
              <Row>
                  {/*<Col sm12 = {1}> <RaisedButton className = "button-table" icon = { <IconWord />   } disabled={this.props.pesateList && this.props.pesateList.length <= 0} onClick = { ()=> this.generateReport(reportDOC)}/></Col>
                     <Col sm12 = {1}> <RaisedButton className = "button-table" icon = { <IconExcel />  } disabled={this.props.pesateList && this.props.pesateList.length <= 0} onClick = { ()=> this.generateReport(reportEXC)}/></Col>
                     <Col sm12 = {1}> <RaisedButton className = "button-table" icon = { <IconPdf/>     } disabled={this.props.pesateList && this.props.pesateList.length <= 0} onClick = { ()=> this.generateReport(reportPDF)}/></Col>
                  <Col sm12 = {1}> <RaisedButton className = "button-table" icon = { <IconRefresh />} onClick={() => (CANUSEPAGE) && this.props.dispatch(getListaPesate(this.state.filter))}/> </Col>*/}
                  <SGButtonsBar list = {btnBarList}/>
              </Row>
            </Grid>
          </div>
          

            {/*Filtri*/}
            <div style={{display: "flex", flexWrap: "wrap"}}>
            {
              this.props.listaFiltri && 
                    this.props.listaFiltri.map( (value, index) => {
                      if(typeof value.Filtro === 'object')
                        var filtro = momentformat(value.Filtro).format("YYYY-MM-DD");
                      else if(typeof value.Filtro === 'string')
                        var filtro = value.Filtro.indexOf("GMT+") > -1 ? momentformat(value.Filtro).format("YYYY-MM-DD") : value.Filtro;
                      else if(typeof value.Filtro === 'boolean')
                        var filtro = value.Filtro ? LABEL_True[USERLANGUAGE] : LABEL_False[USERLANGUAGE];
                      if(value.Campotabella){
                        var label = value.CampoTabella + " = " + filtro
                      }
                      if(this.props.logicalOperators.length === 0) return null;
                      var filtri    = (this.props.logicalOperators.filter( i => {
                          if( !checkNull(i) && !checkNull(value.Operatore) )
                            return i.ID === value.Operatore.ID;
                          else return false;
                        }
                      ) );
                      var nomeFiltro = checkNull( filtri[0]) ? "" : filtri[0].Nome

                      var label = (value.CampoTabella || value.CampoPersonalizzato.Etichetta)+" "+nomeFiltro+" "+filtro

                      return value.CampoTabella !== "IDHolding" && value.CampoTabella !== "IDAzienda" && value.CampoTabella !== "IDImpianto" && 
                      <Chip
                          style={{margin: "10px"}}
                          key={value.ID}
                          onRequestDelete={() => this.handleRequestDeleteFilter(index)}
                        >
                          {label}
                        </Chip>
                      }
                    )
            }
            </div>
            


            <Table
              className       = "shadow"
              height          = { window.innerHeight - 500 +"px" }
              fixedHeader     = { this.state.fixedHeader}
              fixedFooter     = { this.state.fixedFooter}
              selectable      = { this.state.selectable}
              multiSelectable = { this.state.multiSelectable}
              onRowSelection  = { this.handleRowSelection}
              >
              
                <TableHeader
                  displaySelectAll  = { this.state.showCheckboxes  }
                  adjustForCheckbox = { this.state.showCheckboxes  }
                  enableSelectAll   = { this.state.enableSelectAll }>
                    <TableRow>
                      <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_FirstWeightDate[USERLANGUAGE]}  </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_FirstWeight[USERLANGUAGE]}      </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "5%"}}  tooltip="">{LABEL_FirstMPP[USERLANGUAGE]}         </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_SecondWeightDate[USERLANGUAGE]} </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "10%"}} tooltip="">{LABEL_SecondWeight[USERLANGUAGE]}     </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "5%"}}  tooltip="">{LABEL_SecondMPP[USERLANGUAGE]}        </TableHeaderColumn>
                      <TableHeaderColumn style={{width: "5%"}}  tooltip="">{LABEL_Deleted[USERLANGUAGE]}          </TableHeaderColumn>
                    </TableRow>
                </TableHeader>

                <TableBody
                  displayRowCheckbox  = {this.state.showCheckboxes}
                  deselectOnClickaway = {this.state.deselectOnClickaway}
                  showRowHover        = {this.state.showRowHover}
                  stripedRows         = {this.state.stripedRows}
                >
                  {
                    this.props.pesateList.map( (row, index) => (
                    <TableRow key={index} selected={this.isSelectedRow(index)}>
                      <TableRowColumn style = { {width: "10%"} } > <Moment date= { row.PrimaPesata.DataOra } format="DD/MM/YYYY HH:mm"> { row.PrimaPesata.DataOra } </Moment>               </TableRowColumn>
                      <TableRowColumn style = { {width: "10%"} } > { row.PrimaPesata.Peso+" "+row.PrimaPesata.UnitaDiMisura }                                                               </TableRowColumn>
                      <TableRowColumn style = { {width: "5%" } } > { row.PrimaPesata.Mpp }                                                                                                  </TableRowColumn>
                      <TableRowColumn style = { {width: "10%"} } > { (row.SecondaPesata == null) ? 
                                          '-' : <Moment date= { row.SecondaPesata.DataOra } format="DD/MM/YYYY HH:mm"> { row.SecondaPesata.DataOra } </Moment> }</TableRowColumn>
                      <TableRowColumn style = { {width: "10%"} } > { (row.SecondaPesata == null) ? '-' : row.SecondaPesata.Peso+" "+row.SecondaPesata.UnitaDiMisura }                       </TableRowColumn>
                      <TableRowColumn style = { {width: "5%" } } > { (row.SecondaPesata == null) ? '-' : row.SecondaPesata.Mpp }                                                            </TableRowColumn>
                      <TableRowColumn style = { {width: "5%" } } > { row.Cancellata ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE] }                                                                                         </TableRowColumn>
                    </TableRow>
                    ))
                  }
                </TableBody>

            </Table>

            <Dialog
              title={LABEL_Filters[USERLANGUAGE]}
              actions={filterDialogActions}
              modal={true}
              contentStyle={styles.filterDialog}
              autoScrollBodyContent={true}
              open={this.props.dialogFilterOpened}
            >
                <Grid>
                  <Row>
                    <Col xs4={4} sm12={3}>
                      <SelectField
                        floatingLabelText={LABEL_Field[USERLANGUAGE]}
                        value={this.state.customFilter.CampoPersonalizzato }
                        fullWidth={true}
                      errorText={this.state.customFilter.CampoPersonalizzatoError}
                        onChange={(event, index, value) => this.customFilterChange("CampoPersonalizzato", value)}>
                          {  this.props.campiPersonalizzatiList && this.props.campiPersonalizzatiList.map( campo => <MenuItem key={campo.IDMaster} value={campo} primaryText={campo.Nome}/>  ) }
                    </SelectField>
                    </Col>
                    <Col xs4={4} sm12={3}>
                      <SelectField
                          floatingLabelText={LABEL_LogicalOperator[USERLANGUAGE]}
                          value={this.state.customFilter.Operatore}
                          fullWidth={true}
                          errorText={this.state.customFilter.OperatoreError}
                          onChange={(event, index, value) => this.customFilterChange("Operatore", value)}>
                            {  this.props.logicalOperators && this.props.logicalOperators.map( operator => <MenuItem key={operator.ID} value={operator} primaryText={operator.Nome}/>  ) }
                      </SelectField>
                    </Col>
                    <Col xs4={4} sm12={3}>
                      {
                        !this.state.customFilter.CampoPersonalizzato &&
                          <TextField className="input-label"
                            onChange          = { event => this.customFilterChange("Filtro", event.target.value) }
                            hintText          = { LABEL_Enter_Value[USERLANGUAGE]} 
                            fullWidth={true}
                            floatingLabelText = { LABEL_Enter_Value[USERLANGUAGE]}
                            errorText={this.state.customFilter.FiltroError}
                            value             = { this.state.customFilter.Filtro || ""}/>
                        || this.state.customFilter.CampoPersonalizzato.TipoCampo.ID == 3 && // vero o falso
                          <Toggle
                            label    = { LABEL_Enter_Value[USERLANGUAGE]}
                            style    = { styles.toggle }
                            fullWidth= {true}
                            toggled  = { this.state.customFilter.Filtro || false }
                            onToggle = { (obj, checked) => this.customFilterChange("Filtro", checked ) }
                            style={{marginTop:"36px"}}
                          />
                        ||
                          this.state.customFilter.CampoPersonalizzato.TipoCampo.ID == 5 && // DAta
                          <DatePicker
                            floatingLabelText={LABEL_Enter_Value[USERLANGUAGE]}
                            autoOk   = {this.state.autoOk}
                            fullWidth={true}
                            onChange = {(event, date) => this.customFilterChange("Filtro", date )}
                            value    = {this.state.customFilter.Filtro}
                          />
                        ||
                          <TextField className="input-label"
                            onChange          = { event => this.customFilterChange("Filtro", event.target.value) }
                            hintText          = { LABEL_Enter_Value[USERLANGUAGE]}
                            fullWidth={true}
                            floatingLabelText = { LABEL_Enter_Value[USERLANGUAGE]}
                            errorText={this.state.customFilter.FiltroError}
                            value             = { this.state.customFilter.Filtro || ""}/>
                      }
                      
                    </Col>
                    <Col xs4={4} sm12={3}>
                      <RaisedButton
                            icon={<IconAdd/>}
                            primary={true}
                            fullWidth={true}
                            onClick={this.addCustomFilterInList}
                            style={{marginTop:"28px"}}
                        />
                    </Col>
                  </Row>
                </Grid>

                {LABEL_FilterSet[USERLANGUAGE]}
                <List>
                  { this.props.listaFiltri && 
                    this.props.listaFiltri.map( value => {
                      if(value.Campotabella){
                        var label = value.CampoTabella + " = " + value.Filtro
                      }

                      
                      var filtri    = (this.props.logicalOperators.filter( i => {
                          if( !checkNull(i) && !checkNull(value.Operatore) )
                            return i.ID === value.Operatore.ID;
                          else return false;
                        }
                      ) );
                      var nomeFiltro = checkNull(filtri[0]) ? "" : filtri[0].Nome

                      var label = (value.CampoTabella || value.CampoPersonalizzato.Etichetta)+" "+nomeFiltro+" "+value.Filtro

                      return value.CampoTabella !== "IDHolding" && value.CampoTabella !== "IDAzienda" && value.CampoTabella !== "IDImpianto" && <div><ListItem key={value.IDMaster} onClick={() => console.log(value)}> { label } </ListItem></div>
                      }
                    )
                  }
                </List>

            </Dialog>
            

            <Dialog
              title={LABEL_DIALOG_Weigh_Details[USERLANGUAGE]}
              actions={showDetailsActions}
              modal={true}
              contentStyle={styles.filterDialog}
              autoScrollBodyContent={true}
              open={this.props.detailDialogOpened}
            >
              { this.props.detailDialogPesata &&
                <Grid style={{letterSpacing: "1px"}}>
                  <Row>
                    <Col xs4={4} sm12={6}>
                      <Row style={{fontSize:"25px", color : "#6b9add"}}>{LABEL_FirstWeighting[USERLANGUAGE]}</Row>
                      <Row>
                        <Col xs4={2}>{LABEL_Company[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Azienda.Nome}</Col>
                      </Row>
                      <Row>
                        <Col xs4={2}>{LABEL_Plant[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Impianto.Nome}</Col>
                      </Row>
                      <Row>
                        <Col xs4={2}>{LABEL_Libra[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Bilancia.Nome}</Col>
                      </Row>
                      <Row>
                        <Col xs4={2}>{LABEL_User[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Operatore.Username}</Col>
                      </Row>
                      <Row>
                        <Col xs4={2}>{LABEL_FirstWeightDate[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.DataOra}</Col>
                      </Row>
                      <Row>
                        <Col xs4={2}>{LABEL_FirstWeight[USERLANGUAGE]}</Col>
                        <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Peso +" "+this.props.detailDialogPesata.PrimaPesata.UnitaDiMisura}</Col>
                      </Row>
                    </Col>
                    
                    {this.props.detailDialogPesata.SecondaPesata && 
                      <Col xs4={4} sm12={6}>
                        <Row style={{fontSize:"25px", color : "#6b9add"}}>{LABEL_SecondWeighting[USERLANGUAGE]}</Row>
                        <Row>
                          <Col xs4={2}>{LABEL_Company[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Azienda.Nome}</Col>
                        </Row>
                        <Row>
                          <Col xs4={2}>{LABEL_Plant[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Impianto.Nome}</Col>
                        </Row>
                        <Row>
                          <Col xs4={2}>{LABEL_Libra[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Bilancia.Nome}</Col>
                        </Row>
                        <Row>
                          <Col xs4={2}>{LABEL_User[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Operatore.Username}</Col>
                        </Row>
                        <Row>
                          <Col xs4={2}>{LABEL_SecondWeightDate[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.DataOra}</Col>
                        </Row>
                        <Row>
                          <Col xs4={2}>{LABEL_SecondWeight[USERLANGUAGE]}</Col>
                          <Col xs4={2}>{this.props.detailDialogPesata.PrimaPesata.Peso +" "+this.props.detailDialogPesata.PrimaPesata.UnitaDiMisura}</Col>
                        </Row>
                      </Col>
                    }
                    <Row style={{width : "100%", fontSize:"25px", marginLeft: "20px", marginTop: "20px"}}>{LABEL_Number[USERLANGUAGE]} : {this.props.detailDialogPesata.NumeroPesata}</Row>
                    <Row style={{width : "100%", fontSize:"25px", margin: "20px"}}>{LABEL_Net[USERLANGUAGE]} : {this.props.detailDialogPesata.Netto + " "+ this.props.detailDialogPesata.PrimaPesata.UnitaDiMisura}</Row>
                    <div style={{width : "100%", fontSize:"25px", color : "#6b9add", marginBottom: "10px"}}>{ LABEL_PAGE_CustomFields[USERLANGUAGE] }</div>
                    
                    
                    {this.props.detailDialogPesata.CampiPersonalizzati &&
                      this.props.detailDialogPesata.CampiPersonalizzati.map( (campo, i) => (
                            <Row key={i} style={{width : "100%", borderBottom: "1px dotted Gainsboro"}}>
                              <Col xs4={2} sm12={2}>{campo.Name}</Col>
                              <Col xs4={2} sm12={3}>: {campo.Value}</Col>
                            </Row>
                          )
                      )  }
                  </Row>
                </Grid>
              }
            </Dialog>

            <Dialog
              title={LABEL_ExportWeighings[USERLANGUAGE]}
              actions={showDownloadActions}
              modal={true}
              contentStyle={styles.filterDialog}
              autoScrollBodyContent={true}
              open={this.props.downloadDialogOpened}
            >
              <SelectField
                  floatingLabelText = {LABEL_Choose_FileType[USERLANGUAGE]}
                  value             = {this.state.downloadDialog.fileTypeSelected}
                  errorText         = {this.state.downloadDialog.fileTypeSelectedError}
                  onChange          = {this.handleChangeFileType}>
                    {  this.props.fileTypeList && this.props.fileTypeList.map( type => <MenuItem key={type.ID} value={type} primaryText={type.Name}/>  ) }
              </SelectField>

              <TextField 
                  className         = "input-label"
                  onChange          = { event => this.downloadDialogChange("FileName", event.target.value) }
                  hintText          = { LABEL_FileName[USERLANGUAGE]}
                  fullWidth         = {true}
                  floatingLabelText = { LABEL_FileName[USERLANGUAGE]}
                  errorText         = {this.state.downloadDialog.FileNameError}
                  value             = { this.state.downloadDialog.FileName || ""}/>

            </Dialog>
          </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { pesataReducer } = state;
  const { downloadDialogOpened, fileTypeList, isFetching, isAuthenticated, pesateList, errorMessage, impiantiList, detailDialogPesata, detailDialogOpened, aziendeList, campiPersonalizzatiList, dialogFilterOpened, logicalOperators, listaFiltri } = pesataReducer;
  return {
    isFetching,
    pesateList,
    isAuthenticated,
    errorMessage,
    impiantiList,
    aziendeList,
    campiPersonalizzatiList,
    dialogFilterOpened,
    logicalOperators,
    listaFiltri,
    detailDialogOpened,
    detailDialogPesata,
    downloadDialogOpened,
    fileTypeList
  };
}

export default connect(mapStateToProps)(Pesate);


// WEBPACK FOOTER //
// ./src/Containers/Pesate.js